import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55b33be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "End__Background color--1" }, null, -1))
const _hoisted_2 = { class: "End__Subinner section__subinner" }
const _hoisted_3 = { class: "End__Grid End__Main__Wrapper grid" }
const _hoisted_4 = { class: "End__Main" }
const _hoisted_5 = { class: "End__Title" }
const _hoisted_6 = { class: "End__Text" }
const _hoisted_7 = { class: "End__EventContainer" }
const _hoisted_8 = { class: "End__Event" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "End__Event__Bg",
  viewBox: "0 0 482 204",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M465,0H275.5c-3.9,0-7.4,1.4-10.5,3.5c-3.1,2-6,4.7-8.6,7.2c-4,3.9-9.4,6.3-15.4,6.3s-11.4-2.4-15.4-6.3\n                  c-2.6-2.5-5.4-5.2-8.6-7.2c-3.1-2-6.6-3.5-10.5-3.5H17C7.6,0,0,7.6,0,17v170c0,9.4,7.6,17,17,17h192.2c6.8,0,12.6-4.6,17.4-8.7\n                  c3.8-3.3,8.9-5.3,14.3-5.3s10.5,2,14.3,5.3c4.8,4.1,10.6,8.7,17.4,8.7H465c9.4,0,17-7.6,17-17V17C482,7.6,474.4,0,465,0z M480,187\n                  c0,8.3-6.7,15-15,15H272.8c-6,0-11.2-4-16.1-8.2c-4.2-3.6-9.7-5.8-15.6-5.8s-11.4,2.2-15.6,5.8c-4.9,4.2-10.1,8.2-16.1,8.2H17\n                  c-8.3,0-15-6.7-15-15V17C2,8.7,8.7,2,17,2h189.5c3.4,0,6.5,1.3,9.4,3.2c3,1.9,5.7,4.5,8.3,7c4.3,4.2,10.2,6.8,16.8,6.8\n                  s12.5-2.6,16.8-6.8c2.6-2.5,5.3-5.1,8.3-7c2.9-1.9,6.1-3.2,9.4-3.2H465c8.3,0,15,6.7,15,15V187z" })
], -1))
const _hoisted_10 = { class: "End__Event__Left" }
const _hoisted_11 = { class: "End__Event__Right" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "End__Confirmation" }
const _hoisted_15 = { class: "End__Grid End__Visual__Wrapper grid" }
const _hoisted_16 = { class: "End__Visual" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "End__Visual__Background" }, null, -1))
const _hoisted_18 = { class: "picture picture--2" }
const _hoisted_19 = ["srcset"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "picture picture--1" }
const _hoisted_22 = ["srcset"]
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_EventsDate = _resolveComponent("EventsDate")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_AppearObject = _resolveComponent("AppearObject")!

  return (_openBlock(), _createBlock(_Transition, {
    mode: "out-in",
    css: false,
    appear: "",
    onEnter: _ctx.onEnter,
    onAfterEnter: _ctx.onAfterEnter,
    onLeave: _ctx.onLeave
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["End", { active: _ctx.active }])
      }, [
        _createVNode(_component_AppearObject, { class: "End__Inner section__inner" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('events.congratsTitle')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("events.congratsText", {eventName: _ctx.event.name})), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_EventsDate, {
                          date: _ctx.event.start_date,
                          size: "large"
                        }, null, 8, ["date"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("events.where")), 1),
                        _createElementVNode("p", {
                          innerHTML: `${_ctx.event.city}`
                        }, null, 8, _hoisted_12),
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("events.ticketPrice")), 1),
                        _createElementVNode("p", {
                          class: "text-large",
                          innerHTML: `$${_ctx.event.price}`
                        }, null, 8, _hoisted_13)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("events.congratsConfirmation")), 1),
                  _createVNode(_component_ButtonHover, {
                    type: "button",
                    class: "End__GetTicket button button--white",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("events.back")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("picture", _hoisted_18, [
                    _createElementVNode("source", { srcset: `/images/events/end-2.png 1x, /images/events/end-2@2x.png 2x` }, null, 8, _hoisted_19),
                    _createElementVNode("img", {
                      src: `/images/events/end-2.png`,
                      alt: ""
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("picture", _hoisted_21, [
                    _createElementVNode("source", { srcset: `/images/events/end-1.png 1x, /images/events/end-1@2x.png 2x` }, null, 8, _hoisted_22),
                    _createElementVNode("img", {
                      src: `/images/events/end-1.png`,
                      alt: ""
                    }, null, 8, _hoisted_23)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ], 2)
    ]),
    _: 1
  }, 8, ["onEnter", "onAfterEnter", "onLeave"]))
}